/* Employee planning dialog — extracted from BiometricPunch.js (iter83).
 * Configures work hours, late grace and work-days. Preserves all
 * data-testid attributes so e2e tests keep passing. */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

export const PlanningDialog = ({
  open, onOpenChange, planning, setPlanning, savePlanning,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="planning-dialog">
      <DialogHeader>
        <DialogTitle className="font-outfit flex items-center gap-2">
          📅 Planning de l&apos;employé
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label>Heure d&apos;arrivée</Label>
            <input type="time" value={planning.start_time}
              onChange={(e) => setPlanning((p) => ({ ...p, start_time: e.target.value }))}
              className="mt-1 w-full h-10 rounded-md border border-[#E2E8F0] px-3 text-sm bg-white"
              data-testid="planning-start-input" />
          </div>
          <div>
            <Label>Heure de départ</Label>
            <input type="time" value={planning.end_time}
              onChange={(e) => setPlanning((p) => ({ ...p, end_time: e.target.value }))}
              className="mt-1 w-full h-10 rounded-md border border-[#E2E8F0] px-3 text-sm bg-white"
              data-testid="planning-end-input" />
          </div>
        </div>
        <div>
          <Label>Tolérance retard (minutes)</Label>
          <input type="number" min="0" max="120" value={planning.late_grace_minutes}
            onChange={(e) => setPlanning((p) => ({ ...p, late_grace_minutes: e.target.value }))}
            className="mt-1 w-full h-10 rounded-md border border-[#E2E8F0] px-3 text-sm bg-white"
            data-testid="planning-grace-input" />
        </div>
        <div>
          <Label>Jours travaillés</Label>
          <div className="mt-1 flex gap-1 flex-wrap">
            {['L', 'Ma', 'Me', 'J', 'V', 'S', 'D'].map((label, idx) => {
              const active = planning.work_days.includes(idx);
              return (
                <button key={idx} type="button"
                  onClick={() => setPlanning((p) => ({
                    ...p,
                    work_days: active ? p.work_days.filter((d) => d !== idx) : [...p.work_days, idx].sort(),
                  }))}
                  className={`w-10 h-10 rounded font-bold text-sm ${
                    active ? 'bg-[#0052FF] text-white' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
                  }`}
                  data-testid={`planning-day-${idx}`}>
                  {label}
                </button>
              );
            })}
          </div>
          <p className="text-[10px] text-[#94A3B8] mt-1">Cliquez pour activer / désactiver un jour.</p>
        </div>
        <div className="text-xs bg-blue-50 border border-blue-200 rounded p-2 text-blue-800">
          Les alertes RH et le rapport de paie utilisent ce planning pour détecter retards, absences et heures supplémentaires.
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
        <Button onClick={savePlanning} className="bg-emerald-600 hover:bg-emerald-700"
          data-testid="planning-save-btn">
          💾 Enregistrer
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
